import { Component, OnInit } from '@angular/core';
import { ChantiersInfrastructuresService } from './../../Service/ChantiersInfrastructures.service';
import { Global } from './../../Service/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { SharedService } from './../../Service/shared.service';
declare var $: any;

var url = "";

@Component({
  selector: 'app-chantiers-infrastructures',
  templateUrl: './chantiers-infrastructures.component.html',
  styleUrls: ['./chantiers-infrastructures.component.scss']
})
export class ChantiersInfrastructuresComponent implements OnInit {

  activeIndex;
  constructor(
    public global: Global,
    private service: ChantiersInfrastructuresService,
    private aroute: ActivatedRoute,
    private shared: SharedService,
    private router: Router
  ) { }

   
  Chantier = {
    Titre: "",
    Port: "",
    Id: 0
  }
  bloc = {
    Titre: "",
    Contenu: ""
  }
  Chantiers = [];
  FiltrePorts = [];
  ChantierFiltered = [];
  FilteredPorts = [];
  filterPort = '';
  init=true;
  groupBy(list, property) {
    return list.reduce((groups, item) => {
      const val = item[property];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  }
  arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele != value;
    });
  }
  Filter(Port, index) {
    $('#slider-chantier ol').slick('destroy');
  // for(let i=0; i < this.filterPort.length; i++) {
  //  i !== index ? this.activeIndex[i] = false :  this.activeIndex[i] = true;
  // }
  this.activeIndex = index;
   this.ChantierFiltered = [];
    if(this.filterPort === Port) {
      this.ChantierFiltered = this.Chantiers
      this.activeIndex[index] = false;
    }  else {
      this.filterPort = Port;
        this.Chantiers.forEach(element => {
          if (this.filterPort === element.Port) {
            this.ChantierFiltered.push(element);
          }
         
        })
      }

    this.sliderChantier();
  }
  ngOnInit(): void {

    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.shared.getBlocDescriptionByCode(lg.url, "ChantierInfrastructures").subscribe(data => {
        this.bloc.Titre = data["value"][0] ? data["value"][0].Title : "";
        this.bloc.Contenu = data["value"][0] ? data["value"][0].Contenu : "";
      })
    })

    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      if(!this.init){
        this.Chantiers = [];
        this.ChantierFiltered = [];
        $('#slider-chantier ol').slick('destroy');
      }
      this.service.getChantiersInfrastructures(lg.url).subscribe(datas => {
        this.sliderChantier();
        this.Chantiers = [];
        datas["value"].forEach(element => {
          const obj = {
            Titre: element.Title ? element.Title : "",
            Port: element.CodePort ? element.CodePort : "",
            Id: element.Id ? element.Id : "",
            PortImage: element.LienImageProjet !== '' && element.LienImageProjet !== null ? element.LienImageProjet : 'assets/media/images/img-01.png'
          }
          this.Chantiers.push(obj);
          this.ChantierFiltered.push(obj);
        });
        this.FiltrePorts = [];
        // Get Filtered By Port 
        var PortsGroupedBy = this.groupBy(datas["value"], "CodePort")
        PortsGroupedBy = Object.keys(PortsGroupedBy).map(key => PortsGroupedBy[key]);
        PortsGroupedBy.forEach(lm => {
          var obj = {}
          lm.forEach(lm => {
            obj = {
              Port: lm.CodePort,
              Id: lm.Id
            }
          })
          this.FiltrePorts.push(obj);
        })
      });
    })
  }
  sliderChantier() {
    $("document").ready(() => {
      if ($("#slider-chantier").length > 0) {
        $('#slider-chantier ol').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        
        });
        this.init = false;
      }
    });
  }
}

